export default class Arch {
  constructor() {
    this.activeClass = 'is-active';
    this.reverseClass = 'js-arch_reverse_svg';
    this.pathDurationSec = 200;
    this.triggerOffsetFromBottom = 0.2;
    this.preparedArchMap = new WeakMap();
    this.archSvgs = document.querySelectorAll('.js-arch_svg, .js-arch_reverse_svg');

    if (this.archSvgs.length > 0) {
      this.init();
    }
  }

  init() {
    this.prepareArchSvgs();
    this.observeArchSvgs();
  }

  prepareArchSvgs() {
    this.archSvgs.forEach((svg) => this.prepareArch(svg));
  }

  observeArchSvgs() {
    if (!('IntersectionObserver' in window)) {
      this.archSvgs.forEach((svg) => this.archAnimate(svg));
      return;
    }

    const rootMarginBottom = `-${Math.floor(this.triggerOffsetFromBottom * 100)}%`;
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const svg = entry.target;
          currentObserver.unobserve(svg);
          this.archAnimate(svg);
        });
      },
      {
        root: null,
        rootMargin: `0px 0px ${rootMarginBottom} 0px`,
        threshold: 0
      }
    );

    this.archSvgs.forEach((svg) => observer.observe(svg));
  }

  archAnimate(svg) {
    const prepared = this.preparedArchMap.get(svg);
    if (!prepared) {
      return;
    }

    const { paths, dashLens, isReverse } = prepared;
    svg.classList.add(this.activeClass);

    const pathDurationMs = this.pathDurationSec;
    const durations = dashLens.map(() => pathDurationMs);
    const delays = [];
    let totalDelay = 0;

    for (let i = 0; i < durations.length; i += 1) {
      delays[i] = totalDelay;
      totalDelay += durations[i];
    }

    requestAnimationFrame(() => {
      paths.forEach((path, index) => {
        path.style.opacity = '1';
        path.animate(
          [
            { opacity: 1, strokeDashoffset: isReverse ? dashLens[index] : -dashLens[index] },
            { opacity: 1, strokeDashoffset: 0 }
          ],
          {
            duration: Math.max(1, Math.floor(durations[index])),
            delay: Math.floor(delays[index]),
            easing: 'linear',
            fill: 'forwards'
          }
        );
      });
    });
  }

  prepareArch(svg) {
    const paths = Array.from(svg.querySelectorAll('path'));
    if (!paths.length) {
      return;
    }

    const isReverse = svg.classList.contains(this.reverseClass);
    const dashLens = paths.map((path) => {
      const dash = path.getTotalLength();
      path.style.strokeDasharray = `${dash} ${dash}`;
      path.style.strokeDashoffset = `${isReverse ? dash : -dash}`;
      path.style.opacity = '0';
      return dash;
    });

    this.preparedArchMap.set(svg, { paths, dashLens, isReverse });
  }
}